import React from "react";
import {
  Button,
  Heading,
  List,
} from "@aprendaagora/simple-react-component-library";
import { Link } from "react-router-dom";
import atomicdesign from "../../static/images/atomicdesign.png";
import SyntaxHighlighter from "react-syntax-highlighter";
import { atomOneDark } from "react-syntax-highlighter/dist/esm/styles/hljs";
import { GiAtom, GiMolecule, GiInternalOrgan } from "react-icons/gi";

const HomePage = () => {
  const items = [
    { icon: <GiAtom />, text: "atoms" },
    { icon: <GiMolecule />, text: "molecules" },
    { icon: <GiInternalOrgan />, text: "organisms" },
  ];

  const code1 = `import {Button, Heading} from @aprendaagora/simple-react-component-library`;
  return (
    <div>
      <Heading level={4} text="Simple React Component Library" />

      <div className="my-5">
        <Heading level={6} text="Install library" tailwind="mb-2" />
        <SyntaxHighlighter language="javascript" style={atomOneDark}>
          npm install @aprendaagora/simple-react-component-library
        </SyntaxHighlighter>
      </div>

      <div className="my-5">
        <Heading level={6} text="Import component" tailwind="mb-2" />
        <SyntaxHighlighter language="javascript" style={atomOneDark}>
          {code1}
        </SyntaxHighlighter>
      </div>

      <hr className="my-10" />

      <div className="p-5 border mb-10">
        <Heading
          level={5}
          text="There are 3 groups of components in this library"
        />

        <List
          tailwind="mb-5"
          items={items}
          listStyle={{
            marginTop: "20px",
            paddingLeft: "2em",
          }}
          itemStyle={{ marginBottom: "20px" }}
          renderItem={(item) => (
            <Link
              className="hover:underline text-xl flex items-center text-cyan-500"
              to={item.text}
            >
              {item.icon}
              <span className="ml-2">
                {item.text.charAt(0).toUpperCase() + item.text.slice(1)}
              </span>
            </Link>
          )}
        />

        <Heading
          level={6}
          text="The other 2 groups of components (Templates and Pages), must be built by the user using the components in the library."
          tailwind="mb-10"
        />
      </div>

      <img src={atomicdesign} alt="Atomic Design Illustration" />
    </div>
  );
};

export default HomePage;
